module.exports = __webpack_public_path__ + "static/media/icon-expand.79aa2ed6.svg";